import { type User } from '@avanta/shared/types/users';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from 'constants/common';
import { UsersService } from 'services/users';

export const useFetchUser = (userId?: string): UseQueryResult<User | undefined, Error> =>
  useQuery({
    queryKey: [QUERY_KEYS.FETCH_USER, userId],
    queryFn: () => UsersService.getUser(userId),
    select: response => response.data,
    enabled: !!userId,
  });
